import React from "react";

import { useAppSelector, useHandlePageNavigate } from "../../hooks/hooks";
import {
  selectAllReportNotesList,
  selectNotesStatus,
} from "../../features/reports/reportsSlice";

import {
  AnchorLink,
  CollapsableItemList,
  Container,
  Layout,
  Padding,
  Text,
} from "@kidslivesafe/sc-react";

import NoteLineItem from "../../components/UIComponents/NoteLineItem/NoteLineItem";
import LoadingContainerLineItem from "../../components/UIComponents/LoadingContainerLineItem/LoadingContainerLineItem";

const NotesDashboardContainer: React.FC = () => {
  const pageNavigate = useHandlePageNavigate();

  const handleClick = () => {
    pageNavigate("/your-notes");
  };

  const notes = useAppSelector(selectAllReportNotesList);
  const sortedNotes = notes
    ? [...notes].sort((a, b) => {
        const aDate = a.lastActivityDate;
        const bDate = b.lastActivityDate;

        if (aDate > bDate) {
          return -1;
        }
        if (aDate < bDate) {
          return 1;
        }
        return 0;
      })
    : [];

  const notesStatus = useAppSelector(selectNotesStatus);
  const loading = notesStatus === "loading";

  return (
    <>
      <Padding left="md" right="md">
        <Container
          containerTitle="Notes on Reports"
          containerId="dashboard__notes__container"
          tooltipContent="All reports in this section have your notes associated with them. Click “View All Notes” to see all of the reports that you have added notes to."
        >
          <CollapsableItemList>
            {loading ? (
              Array(5)
                .fill(null)
                .map((_, index) => (
                  <LoadingContainerLineItem
                    lineItemHeader
                    lineItemSubHeader
                    lineItemDetails
                    key={index}
                  />
                ))
            ) : sortedNotes && sortedNotes.length > 0 ? (
              sortedNotes
                .slice(0, 5)
                .map(note =>
                  note && note.reportNotesCount !== 0 ? (
                    <NoteLineItem
                      key={note.id}
                      note={note}
                      loading={loading}
                      loadingKey={note.lastActivityDate}
                    />
                  ) : null,
                )
            ) : (
              <Padding space="md">
                <Text size="sm">
                  Your five most recent reports with notes added will appear
                  here. To add a note, open a report and enter your note at the
                  bottom. Once added, the report will show up here.
                </Text>
              </Padding>
            )}
          </CollapsableItemList>
          {notes && notes.length > 0 && (
            <Padding space="md" top="none">
              <Layout type="flex" flexProps={{ justifyContent: "center" }}>
                <AnchorLink
                  handleClick={handleClick}
                  role="button"
                  hoverUnderline
                  size="xs"
                  fontWeight="semibold"
                >
                  View All Notes on Reports
                </AnchorLink>
              </Layout>
            </Padding>
          )}
        </Container>
      </Padding>
    </>
  );
};

export default NotesDashboardContainer;
